import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { useTenant } from '../../hooks/useTenant'
import { DetailEntityPage } from '../DetailEntityPage/DetailEntityPage'
import { TenantGroupBadge } from '../../components/TenantGroupBadge/TenantGroupBadge'
import { formatDate } from '../../helpers/formatDate'
import type { DetailFieldDef } from '../../types'

export function TenantDetailPage() {
  const { id } = useParams<{ id: string }>()
  const { tenant, isLoading, error } = useTenant(id ?? '')

  const fields: DetailFieldDef[] = tenant
    ? [
        {
          label: 'ID',
          value: <span className="font-monospace small">{tenant.id}</span>,
        },
        {
          label: 'Code',
          value: <span className="fw-medium">{tenant.code}</span>,
        },
        { label: 'Name', value: tenant.name },
        {
          label: 'Tenant Group',
          value: <TenantGroupBadge tenantGroupId={tenant.tenantGroupId} />,
        },
        { label: 'Created', value: formatDate(tenant.createdAt) },
        { label: 'Updated', value: formatDate(tenant.updatedAt) },
      ]
    : []

  return (
    <DetailEntityPage
      title={tenant ? `Tenant - ${tenant.code}` : 'Tenant'}
      loadingLabel="tenant"
      fields={fields}
      isLoading={isLoading}
      error={error}
      actions={
        id ? (
          <Link to={`/tenants/${id}/edit`} className="btn btn-primary btn-sm">
            Edit
          </Link>
        ) : undefined
      }
    />
  )
}
